import React, { useState } from "react";
import parentImage from "../assets/images/parent-page/parent-image.png";
import howItWorksImage from "../assets/images/parent-page/how-it-works.png";
import featureImage from "../assets/images/parent-page/feature.png";
import miniGameImage from "../assets/images/parent-page/mini-game.png";
import contactUsImage from "../assets/images/parent-page/contact-us.png";
import socialMediaImage from "../assets/images/social-media.png";
import iconAppImage from "../assets/images/icon-app.png";
import appStoreImage from "../assets/images/app-store.png";
import playStoreImage from "../assets/images/play-store.png";
import plusIcon from "../assets/svgs/faqs/plus.svg";
import minusIcon from "../assets/svgs/faqs/minus.svg";
import "../styles/parent-page.css";
import { Button, TextField } from "@mui/material";
import { faqData } from "src/data/faq-parent-data";
import { Link } from "react-router-dom";
import useApiServices from "src/api/useApiServices";
import FormProvider, { RHFTextField } from "src/components/hook-form";
import { useForm } from "react-hook-form";
import { enqueueSnackbar } from "notistack";

interface ParentPageProps {}

const ParentPage: React.FC<ParentPageProps> = () => {
  const [expandItemId, setExpandItemId] = useState<number>(1);
  const { usePostApi } = useApiServices();
  const methods = useForm({});
  const { handleSubmit } = methods;

  const { mutate: contactUs, isLoading: isLoadingContactUs } = usePostApi({
    url: "/contact",
    withSuccessNotistack: false,
    onSuccess: (data: any) => {
      enqueueSnackbar({
        variant: "success",
        message: data?.message,
        anchorOrigin: { vertical: "top", horizontal: "right" },
      });
    },
  });

  const onSubmit = handleSubmit((data: any) => {
    contactUs({
      ...data,
    });
  });

  return (
    <>
      <div className="header">
        <div className="header-navbar">
          <img
            src={iconAppImage}
            alt=""
            className="img-logo"
            onClick={() => (window.location.href = "/parent-page/")}
          />
          <div className="nav-link">
            <h2
              className="h2-nav-link"
              onClick={() => (window.location.href = "#how-it-works")}
            >
              HOW IT WORKS?
            </h2>
            <h2
              className="h2-nav-link"
              onClick={() => (window.location.href = "#features")}
            >
              FEATURES
            </h2>
            <h2
              className="h2-nav-link"
              onClick={() => (window.location.href = "#faqs")}
            >
              FAQS
            </h2>
            <h2
              className="h2-nav-link"
              onClick={() => (window.location.href = "#contact-us")}
            >
              CONTACT
            </h2>
          </div>
          <Button
            className="button-nav-link"
            component={Link}
            to="/child-page/"
          >
            CHILD’S WEBSITE
          </Button>
        </div>
        <div className="header-contant">
          <div className="header-contant-text-left">
            <div className="text-left-header-contant">
              <h1 className="h1-header-contant-text-left">
                {"Keep Your Child Engaged, Stay in Control - Invisibly!".toUpperCase()}
              </h1>
              <p className="p-header-contant-text-left">
                Your child enjoys meaningful conversations with a friendly
                character, while you shape the responses without them ever
                knowing!
              </p>
            </div>
            <div className="button-left">
              <Button className="button-watch-tutorial">Watch Tutorial</Button>
              <Button
                className="button-download"
                onClick={() => (window.location.href = "#download-app")}
              >
                Download
              </Button>
            </div>
          </div>
          <div className="header-contant-img-right">
            <img src={parentImage} alt="" className="header-img" />
          </div>
        </div>
      </div>

      {/* How it works? */}
      <div className="how-it-works" id="how-it-works">
        <div className="header-how-it-works">
          <h2 className="custom-h2">How it works?</h2>
          <p className="custom-p">
            We have a tutorial video to guide you through our amazing app
            dedicated for your child!
          </p>
        </div>
        <div>
          <img src={howItWorksImage} alt="" className="img-how-it-works" />
        </div>
      </div>

      {/* features */}
      <div className="features" id="features">
        <div className="header-section">
          <h2 className="custom-h2">Features</h2>
          <p className="custom-p">Choose which feature to show on the screen</p>
        </div>
        <div>
          <img src={featureImage} alt="" className="img-features" />
        </div>
      </div>
      <div className="header-section" id="download-app">
        <h2 className="custom-h2" style={{ color: "#95216f" }}>
          GET IT NOW
        </h2>
      </div>
      <div className="download-app-parent">
        <Button
          onClick={() => {
            window.open(
              "https://apps.apple.com/ae/app/darayish-parent/id6743008391",
              "_blank"
            );
          }}
        >
          <img src={appStoreImage} alt="" className="app-store-button" />
        </Button>
        <Button
          onClick={() => {
            window.open(
              "https://play.google.com/store/apps/details?id=org.misraj.darayishParent",
              "_blank"
            );
          }}
        >
          <img src={playStoreImage} alt="" className="play-store-button" />
        </Button>
      </div>

      {/* mini-game */}
      <div className="mini-game">
        <img src={miniGameImage} alt="" className="img-mini-game" />
      </div>

      <div className="header-section">
        <h2 className="custom-h2" style={{ color: "#95216f" }}>
          GET IT NOW
        </h2>
      </div>
      <div className="download-app-parent">
        <Button
          onClick={() => {
            window.open(
              "https://apps.apple.com/ae/app/darayish-parent/id6743008391",
              "_blank"
            );
          }}
        >
          <img src={appStoreImage} alt="" className="app-store-button" />
        </Button>
        <Button
          onClick={() => {
            window.open(
              "https://play.google.com/store/apps/details?id=org.misraj.darayishParent",
              "_blank"
            );
          }}
        >
          <img src={playStoreImage} alt="" className="play-store-button" />
        </Button>
      </div>

      {/* faqs */}
      <div className="faqs" id="faqs">
        <div className="header-section">
          <h2 className="custom-h2">FAQs</h2>
          <p className="custom-p">
            We have answered the most essential questions that might come to
            your mind
          </p>
        </div>
        {faqData?.en.map((item) => (
          <div className="faqs-question">
            <div className="faqs-header">
              <h4 className="h4-faqs-question">{item.title}</h4>
              <div>
                <Button onClick={() => setExpandItemId(item.id)}>
                  {expandItemId == item.id ? (
                    <img src={minusIcon} alt="" />
                  ) : (
                    <img src={plusIcon} alt="" />
                  )}
                </Button>
              </div>
            </div>
            <p
              className="p-faqs-question"
              style={{
                display: expandItemId == item.id ? undefined : "none",
                whiteSpace: "pre-line",
              }}
            >
              {item.description}
            </p>
          </div>
        ))}
      </div>

      {/* contact us */}
      <div className="contact-us" id="contact-us">
        <div className="header-section">
          <h2 className="custom-h2">Contact Us</h2>
          <p className="custom-p">
            We have answered the most essential questions that might come to
            your mind
          </p>
        </div>
        <div className="contact-us-contant">
          <img src={contactUsImage} alt="" className="contact-us-img" />
          <div className="contact-us-form">
            <FormProvider methods={methods} onSubmit={onSubmit}>
              <RHFTextField
                label="Full Name"
                name="fullName"
                className="input-form-contact-us"
              />
              <RHFTextField
                label="Email"
                name="email"
                className="input-form-contact-us"
              />
              <RHFTextField
                label="Message"
                className="input-form-contact-us"
                name="message"
                multiline
                rows={6}
              />
              <Button className="button-form-contact-us" type="submit">
                Send Message
              </Button>
            </FormProvider>
          </div>
        </div>
      </div>

      {/* footer */}
      <div className="footer">
        <div className="footer-contant">
          <div className="footer-left">
            <img src={iconAppImage} alt="" />
            <p className="footer-text-left">
              © All rights reserved for Misraj Technology 2025
            </p>
          </div>
          <div className="footer-right">
            <h2 className="footer-text-right">FOLLOW US</h2>
            <img src={socialMediaImage} alt="" />
          </div>
        </div>
      </div>
    </>
  );
};

export default ParentPage;
